import {
    IAppOptions, MgdRoutes
} from "@shopliftr/common-ng";
import { IAppConfig } from "./common/interfaces/app-config";
import { environment } from "../environments/environment";
import { APP_CONFIG } from "./common/constants/app-config-token";
import { AppRouterService } from "./common/services/app-router.service";
import { AppService } from "./common/services/app.service";
import { PartnerRoutingId } from "./common/enums/partner-routing-id";
import { WELCOME_FEATURE_GROUP_ID } from "./welcome/constants/welcome-feature-group-id.constant";
import { API_CREDENTIALS_FEATURE_GROUP_ID } from "./api-credentials/constants/api-credentials-feature-group-id.constant";
import { DEALS_API_FEATURE_GROUP_ID } from "./deals-api/constants/deals-api-feature-group-id.constant";
import { INSPIRE_FEATURE_GROUP_ID } from "./inspire/constants/inspire-feature-group-id.constant";

export const APP_ROUTES: MgdRoutes = [
    {
        path: "",
        redirectTo: "welcome",
        pathMatch: "full"
    },
    {
        path: "welcome",
        loadChildren: () => import("./welcome/welcome.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "Welcome",
            routeId: PartnerRoutingId.Welcome,
            childFeatureGroupId: WELCOME_FEATURE_GROUP_ID,
            sidenavLink: {
                icon: "home",
                title: "Welcome",
                tooltip: "Welcome"
            }
        }
    },
    {
        path: "credentials",
        loadChildren: () => import("./api-credentials/api-credentials.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "API Credentials",
            routeId: PartnerRoutingId.ApiCredentials,
            childFeatureGroupId: API_CREDENTIALS_FEATURE_GROUP_ID,
            sidenavLink: {
                icon: "vpn_key",
                title: "API Credentials",
                tooltip: "API Credentials"
            }
        }
    },
    {
        path: "deals-api",
        loadChildren: () => import("./deals-api/deals-api.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "Deals API",
            routeId: PartnerRoutingId.DealsApi,
            childFeatureGroupId: DEALS_API_FEATURE_GROUP_ID,
            sidenavLink: {
                icon: "local_offer",
                title: "Deals API",
                tooltip: "Deals API",
                permissions: ["api-docs-read"]
            }
        }
    },
    {
        path: "inspire",
        loadChildren: () => import("./inspire/inspire.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "INSPIRE",
            routeId: PartnerRoutingId.Inspire,
            childFeatureGroupId: INSPIRE_FEATURE_GROUP_ID,
            sidenavLink: {
                icon: "widgets",
                title: "INSPIRE",
                tooltip: "INSPIRE",
                permissions: ["inspire-docs-read"]
            }
        }
    }
];

export const APP_OPTIONS: IAppOptions<IAppConfig> = {
    config: environment,
    configInjectionToken: APP_CONFIG,
    appRouterService: AppRouterService,
    appService: AppService,
    routes: APP_ROUTES,
    useLocalizations: false
};
